import { render, staticRenderFns } from "./CFCreditorDetailsLayout.vue?vue&type=template&id=e9788080&"
import script from "./CFCreditorDetailsLayout.vue?vue&type=script&lang=ts&"
export * from "./CFCreditorDetailsLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports